import * as t from '$trans';
import type { SelectOption } from '@melt-ui/svelte';
import type { JobContractTypeEnum } from '$gql/graphql';
import { jobContractTypeEnumValues } from '$gql/zod-generated';
import type { Choice } from '$components/Form/PrettyChoice.svelte';

export function valueToLabel(value: JobContractTypeEnum, lang: string): string {
    return t.job.contract_type_enum({ enum: value }, lang);
}

export function selectOptions(
    lang: string,
): readonly SelectOption<JobContractTypeEnum>[] {
    return jobContractTypeEnumValues.map((v) => valueToOption(v, lang));
}

export function prettyChoices(lang: string): readonly Choice<JobContractTypeEnum>[] {
    return jobContractTypeEnumValues.map((v) => ({
        value: v,
        key: v,
        label: valueToLabel(v, lang),
    }));
}

export function valueToOption(
    value: JobContractTypeEnum,
    lang: string,
): SelectOption<JobContractTypeEnum> {
    return {
        value,
        label: valueToLabel(value, lang),
    };
}
